/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccAdvancedPatientDetails } from './PccAdvancedPatientDetails';
import {
    PccAdvancedPatientDetailsFromJSON,
    PccAdvancedPatientDetailsFromJSONTyped,
    PccAdvancedPatientDetailsToJSON,
} from './PccAdvancedPatientDetails';

/**
 * 
 * @export
 * @interface FindOnePccAdvancedPatientDetails200Response
 */
export interface FindOnePccAdvancedPatientDetails200Response {
    /**
     * 
     * @type {PccAdvancedPatientDetails}
     * @memberof FindOnePccAdvancedPatientDetails200Response
     */
    data?: PccAdvancedPatientDetails;
}

/**
 * Check if a given object implements the FindOnePccAdvancedPatientDetails200Response interface.
 */
export function instanceOfFindOnePccAdvancedPatientDetails200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOnePccAdvancedPatientDetails200ResponseFromJSON(json: any): FindOnePccAdvancedPatientDetails200Response {
    return FindOnePccAdvancedPatientDetails200ResponseFromJSONTyped(json, false);
}

export function FindOnePccAdvancedPatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePccAdvancedPatientDetails200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PccAdvancedPatientDetailsFromJSON(json['data']),
    };
}

export function FindOnePccAdvancedPatientDetails200ResponseToJSON(value?: FindOnePccAdvancedPatientDetails200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PccAdvancedPatientDetailsToJSON(value.data),
    };
}

